<template lang="pug">
    figure.article-image(ref='animation' :class='color')
        .article-image__curtain(ref='curtain')
        img.article-image__img(
            v-if='name'
            :alt='text'
            ref='img'
            :src='require(`../../assets/img/articles/part-${curPartIndex + 1}/article-${curArticIndex + 1}/photos/${name}`)'
            )
        .article-image__title-wrap(ref='titleWrap')
            span.article-image__title(ref='title' v-html='text')
</template>
<script>
import {gsap} from 'gsap';
import {parts} from '@/assets/data/menu';
import {mixinAnimation} from '../mixins/mixinAnimation';

export default {
    data() {
        return {
            timeline: null,
            instance: null,
            curPartID: this.$route.params.part,
            curArticID: this.$route.params.article
        };
    },
    props: {
        name: String,
        text: String,
        isActive: Boolean,
        color: String,
        animated: {
            type: Boolean,
            default: true
        }
    },
    mixins: [mixinAnimation],
    computed: {
        curPartIndex() {
            return parts.indexOf(parts.find(item => item.id === this.curPartID));
        },
        curArticIndex() {
            return parts[this.curPartIndex]['articles'].indexOf(parts[this.curPartIndex]['articles'].find(item => item.id === this.curArticID));
        }
    },
    methods: {
        createAnimation() {
            if (!this.animated || !this.name) return;
            this.createTimeline();
            this.createScroll('top-bottom', 'middle-middle');
        },
        createTimeline() {
            this.timeline = gsap.timeline({paused: true});
            this.timeline
                .set([this.$refs.img, this.$refs.titleWrap], {opacity: 0})
                .set(this.$refs.title, {x: '100%'}, 'start')
                .set(this.$refs.titleWrap, {opacity: '0'})
                .to(this.$refs.curtain, {duration: 6, scaleY: 1, scaleX: 1, transformOrigin: '0 100%', ease: 'power2.inOut'}, 'start+=3')
                .set([this.$refs.img, this.$refs.titleWrap], {opacity: 1})
                .to(this.$refs.curtain, {duration: 3, scaleY: 0, transformOrigin: '0 100%', ease: 'power2.inOut'})
                .to(this.$refs.title, {duration: 3, x: 0, ease: 'power2.inOut'});
        }
    }
};
</script>
<style lang="scss" scoped>
@import '../../assets/css/vars.scss';
.black {
    .article-image {
        &__title {
            color: var(--color-white);
        }
        // &__curtain {
        //     // background-color: var(--color-white);
        // }
        &__title-wrap {
            border-bottom: 5px var(--color-white) dotted;
        }
    }
}
.white {
    .article-image {
        // &__curtain {
        //     // background-color: var(--color-black);
        // }
        &__title-wrap {
            border-bottom: 5px var(--color-black) dotted;
        }
    }
}
.article-image {
    position: relative;
    overflow: hidden;
    @media (--viewport-tablet) {
        // margin: 10px 0;
    }
    &__curtain {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        z-index: 1;
        transform: scaleY(0);
        background-color: var(--theme);
    }
    &__title {
        font-family: var(--accent);
        padding: 1.2em 1.2em 1em;
        line-height: 1.125;
        display: block;
        color: var(--color-black);
        font-style: normal;
        font-weight: bold;
        font-size: 14px;
        text-transform: uppercase;
    }
    &__img {
        display: block;
        width: 100%;
        height: auto;
        @media (--viewport-mobile-lp) {
            max-height: calc(85 * var(--vh) - 56px);
            width: 100%;
            object-fit: cover;
        }
    }
}
</style>
